import React from "react";
import CourseLockedBottomSheet from "../CourseLockedBottomSheet/CourseLockedBottomSheet";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { getLockedContentText } from "@src/utils";
import { safeJsonParse } from "@src/utils/safeJsonParse";
import { useTranslation } from "react-i18next";

const TestIsTemporarilyLockedBottomSheet = () => {
  const { t } = useTranslation();
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showTestIsTemporarilyLockedBottomSheet
  );

  const item = safeJsonParse(localStorage.getItem("currentItem"), {
    source: "TestIsTemporarilyLockedBottomSheet [localStorage.currentItem]",
    fallback: {},
  });
  let scheduledFromDateText = item?.scheduledFromDateText;
  let scheduledToDateText = item?.scheduledToDateText;
  let isPurchased = item?.isPurchased;
  let isScheduled = item?.isScheduled;
  let isLocked = item?.isLocked;
  // let showBtn = isScheduled || (!isPurchased && isLocked) ? 1 : 0;
  let showBtn = isPurchased ? 0 : isLocked;

  const dispatch = useDispatch();
  return (
    <CourseLockedBottomSheet
      mainText={t(
        "components.bottomSheets.components.testIsTemporarilyLockedBottomSheet.testIsTemporarilyLockedNewText",
        "Your Content is Locked"
      )}
      subText={getLockedContentText(
        scheduledFromDateText,
        scheduledToDateText,
        isPurchased,
        isScheduled,
        isLocked
      )}
      btnText={t(
        "components.bottomSheets.components.testIsTemporarilyLockedBottomSheet.okay",
        "Okay"
      )}
      btnAction={() =>
        dispatch(
          actionCreator.showTestIsTemporarilyLockedBottomSheetAction(false)
        )
      }
      viewAllSubText={
        showBtn
          ? t(
              "components.bottomSheets.components.contentLockedBottomSheet.goBackInstead",
              "Go back instead"
            )
          : t(
              "components.bottomSheets.components.contentLockedBottomSheet.goBack",
              "Go back"
            )
      }
      state={state}
      dispatcher={() =>
        dispatch(
          actionCreator.showTestIsTemporarilyLockedBottomSheetAction(false)
        )
      }
      showBtn={showBtn}
    />
  );
};

export default TestIsTemporarilyLockedBottomSheet;
